import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    delay: { type: Number, default: 3000 }
  }

  connect() {
    setTimeout(() => {
      window.location.href = this.urlValue
    }, this.delayValue)
  }
}

